import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getMyTenantsQueryOptions } from '@/api/tenant';
import type { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

type SaveTenantCustomerIdentityProps = {
  image?: File;
  logoId?: null;
  primaryColor?: string | null;
  secondaryColor?: string | null;
  tenantId: string;
};

type UseSaveTenantCustomerIdentityOptions = {
  mutationConfig?: MutationConfig<typeof saveTenantCustomerIdentity>;
};

export const saveTenantCustomerIdentity = ({
  tenantId,
  ...customerIdentity
}: SaveTenantCustomerIdentityProps) => {
  return extractData(api.tenants({ id: tenantId })['customer-identity'].put(customerIdentity));
};

export const useSaveTenantCustomerIdentity = ({
  mutationConfig,
}: UseSaveTenantCustomerIdentityOptions = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...mutationConfig,
    mutationFn: saveTenantCustomerIdentity,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({
        queryKey: getMyTenantsQueryOptions().queryKey,
      });

      return mutationConfig?.onSuccess?.(...args);
    },
  });
};
